import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import ITravelPassVipSlideData from '@app/types/data/slides/ITravelPassVipSlideData';
import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';

/**
 * Transform for 015-TravelPassSlide
 */
export default class TravelPassSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'TravelPassVipSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<ITravelPassVipSlideData> {
		return {
			...(await super.transform(slide, presentationSettings)),
			prices: {
				adult: slide.fields.priceAdult,
				child: slide.fields.priceChild
			}
		};
	}
}
